
const state = {
  init: {}
}

const mutations = {
  SET_INIT: (state, data) => {
    state.init = data
  }
}

const actions = {
  getInit({
    commit
  }) {
    return new Promise((resolve, reject) => {

    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
